/*
 * @Author: Teemo Ding
 * @Date: 2021-07-15 10:25:19
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-06 10:01:17
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Communication/List/config.tsx
 */
import React from 'react';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { calculateCommunication } from '../tool';
import css from './css.module.less';

export const breadcrumbData = ({ getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/settings',
    name: getI18n('general.sider.settings'),
  },
  {
    url: '',
    name: getI18n('general.sider.communication'),
  },
];

export const columns = (
  editAction,
  deleteAction,
  disableView,
  disableDelete,
  { getI18n },
) => [
  {
    title: getI18n('storeCommunicationSetting.list.communicationGatewayName'),
    dataIndex: 'name',
    key: 'name',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 320,
  },
  {
    title: getI18n(
      'storeCommunicationSetting.list.communicaitonGatewayProvider',
    ),
    dataIndex: 'gatewayProvider',
    key: 'gatewayProvider',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 256,
    render: (text, recode) => {
      const renderText = calculateCommunication(text, recode.channelType, {
        getI18n,
      }).gateway;
      return (
        <NoWrapContainer>
          <GlobalTooltip title={renderText}>{renderText}</GlobalTooltip>
        </NoWrapContainer>
      );
    },
  },
  {
    title: getI18n('storeCommunicationSetting.list.communicationChannel'),
    dataIndex: 'channelType',
    key: 'channelType',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 352,
    render: (text, recode) => {
      const renderText = calculateCommunication(recode.gatewayProvider, text, {
        getI18n,
      }).channelType;

      return (
        <NoWrapContainer>
          <GlobalTooltip title={renderText}>{renderText}</GlobalTooltip>
        </NoWrapContainer>
      );
    },
  },

  disableView && disableDelete
    ? {}
    : {
        title: getI18n(
          'general.advancedFilters.commonStoreProductsWithTable.actions',
        ),
        dataIndex: 'action',
        key: 'action',
        default: true,
        optional: false,
        className: css.columnClass,
        width: 120,
        align: 'center',
        render: (text, record) => (
          <div className={css.action}>
            {disableView ? null : (
              <span onClick={() => editAction(record)} className={css.edit}>
                {getI18n('general.edit')}
              </span>
            )}
            {disableDelete ? null : (
              <span onClick={() => deleteAction(record)} className={css.delete}>
                {getI18n('general.delete')}
              </span>
            )}
          </div>
        ),
      },
];
